import {Component, OnInit, ViewChild} from '@angular/core';
import {Chunker} from '../framework/chunker';
import {FrameworkHttpService} from '../framework/http/service';
import {QARService, ReportParticipationEntity, ReportRowEntity} from '../services/qar.service';
import {AppUser, AppUserData} from '../framework/AppUser';
import {UITableComponent} from '../framework/ui/table';
import {json} from 'body-parser';


@Component({
	selector: 'app-page-report-rejected-users',
	templateUrl: './report-rejected-users.html',
	providers: [QARService, AppUser]
})
export class ReportRejectedUsersPageComponent implements OnInit {

	public reports = {
		loading: false,
		selected: null,
		selectedId: null,
		chunker: (new Chunker([])),
		chunkedData: [],
		tableHeaders: [
			{id: 'name', label: 'Report', filterable: true},
			{id: 'year', label: 'Year', filterable: true},
			{id: 'statusId', label: 'Status', filterable: true},
			{id: 'opened', label: 'Date Opened'},
			{id: 'closed', label: 'Date Closed'},
		],
	};
	public static selfStatic = null;

	@ViewChild('tableRejected') tableRejectedComponent: UITableComponent;


	public verificationDropdown = {
		hidden: {},
		options: {
			ticket_to_be_created: 'Ticket to be created',
			ticket_created: 'Ticket created',
			ticket_in_progress: 'Ticket in progress',
			ticket_closed: 'Ticket closed',
			issue: 'Issue',
			done_verified: 'Done & Verified',
		}
	};

	public verificationDropdown_optionsForFilter() {
		const ret: {} = this.verificationDropdown.options;
		ret['all_but_done_verified'] = 'All Non Done & Verified';
		return ret;
	}

	public rejected = {
		waitCount: 0,
		chunker: new Chunker([]),
		chunkedData: [],
		loading: false,
		loadingRejectedUser: false,
		tableHeaders: [
			{label: 'System', id: 'System', filterable: true, idFunction: ReportRejectedUsersPageComponent.row_value_System},
			{label: 'User Login', id: 'UserLogin', filterable: true, idFunction: ReportRejectedUsersPageComponent.row_value_UserLogin},
			{label: 'User Name', id: 'UserName', filterable: true, idFunction: ReportRejectedUsersPageComponent.row_value_UserName},
			{
				label: 'User Name in System',
				id: 'UserNameInSystem',
				filterable: true,
				idFunction: ReportRejectedUsersPageComponent.row_value_UserNameInSystem
			},
			{label: 'Role Name', id: 'RoleName', filterable: true, idFunction: ReportRejectedUsersPageComponent.row_value_RoleName},
			{
				label: 'Status',
				id: 'StatusId',
				filterable: true,
				type: 'dropdown',
				options: {choices: {Wait: 'Wait', Implement: 'Implement', all: 'All'}},
				idFunction: ReportRejectedUsersPageComponent.row_value_Status
			},
			{label: 'Reason', id: 'Reason', filterable: true, idFunction: ReportRejectedUsersPageComponent.row_value_Reason},
			{label: 'Open Report'},
			{id: 'Comments', label: 'Comments', filterable: true, idFunction: ReportRejectedUsersPageComponent.row_value_Comments},
			{label: 'Verification', filterable: true, type: 'dropdown', options: {choices: this.verificationDropdown_optionsForFilter()}, idFunction: ReportRejectedUsersPageComponent.row_value_verification},
			// {label: 'Check', filterable: true, idFunction: ReportRejectedUsersPageComponent.row_value_CheckStatus, type: 'dropdown', options: {choices: {na: 'Not Checked', exists: 'Access still Exists', removed: 'Access Removed'}}},
			{label: 'Action', filterable: false, id: ''},
		],
		reasons: ReportRowEntity.reasons
	};

	static row_value_verification(row, columnId, filterValue) {
		if (filterValue && filterValue === 'all_but_done_verified') {
			return row.LastCheckedStatus === 'done_verified' ? 'done_verified' : 'all_but_done_verified';
		}
		return row.LastCheckedStatus;
	}

	static row_value_System(row) {
		return row.SystemBatchRow.SystemRole.System.Name;
	}

	static row_value_UserLogin(row) {
		return row.SystemBatchRow.SORUser.Login;
	}

	static row_value_UserName(row) {
		return row.SystemBatchRow.SORUser.FirstName + ' ' + row.SystemBatchRow.SORUser.LastName;
	}

	static row_value_RoleName(row) {
		return row.SystemBatchRow.RoleName;
	}

	static row_value_Status(row) {
		return row.ReportParticipation.StatusId === 'counter_signed' ? 'Implement' : 'Wait';
	}

	static row_value_Reason(row) {
		return ReportRowEntity.reasons[row.OverridenStatusId === 'rejected' ? row.OverridenRejectionReason : row.RejectionReason];
	}

	static row_value_Comments(row) {
		return row.RejectedUserComments;
	}

	static row_value_UserNameInSystem(row) {
		return row.SystemBatchRow.UserName;
	}

	static row_value_CheckStatus(row) {
		console.log(ReportRejectedUsersPageComponent.selfStatic);
		if (ReportRejectedUsersPageComponent.selfStatic && ReportRejectedUsersPageComponent.selfStatic.testAccess.testingResult[row.SystemBatchRow.Id]) {
			return ReportRejectedUsersPageComponent.selfStatic.testAccess.testingResult[row.SystemBatchRow.Id].AccessExists ? 'exists' : 'removed';
		}
		return 'na';
	}

	downloadAsExcelRowFormatter(headerId, currentValue, row) {
		console.log('downloadAsExcelRowFormatter', headerId, currentValue, row);
		switch (headerId) {
			case 'UserNameInSystem':
				return ReportRejectedUsersPageComponent.row_value_UserNameInSystem(row);
			case 'System':
				return ReportRejectedUsersPageComponent.row_value_System(row);
			case 'UserLogin':
				return ReportRejectedUsersPageComponent.row_value_UserLogin(row);
			case 'UserName':
				return ReportRejectedUsersPageComponent.row_value_UserName(row);
			case 'RoleName':
				return ReportRejectedUsersPageComponent.row_value_RoleName(row);
			case 'StatusId':
				return ReportRejectedUsersPageComponent.row_value_Status(row);
			case 'Reason':
				return ReportRejectedUsersPageComponent.row_value_Reason(row);
			case 'Comments':
				return ReportRejectedUsersPageComponent.row_value_Comments(row);
		}
	}

	downloadAsExcelHeaders() {
		return [
			{label: 'System', id: 'System'},
			{label: 'User Login', id: 'UserLogin'},
			{label: 'User Name', id: 'UserName'},
			{label: 'User Name in System', id: 'UserNameInSystem'},
			{label: 'Role Name', id: 'RoleName'},
			{label: 'Status', id: 'StatusId'},
			{label: 'Reason', id: 'Reason'},
			{label: 'Comments', id: 'Comments'}
		];
	}

	constructor(public api: QARService, public user: AppUser) {
	}

	ngOnInit() {
		ReportRejectedUsersPageComponent.selfStatic = this;
		this.reports_init();
	}

	public reports_init() {
		this.reports.loading = true;
		this.api.retrieveQARReportsForReportBrowser().then(r => {
			this.reports.loading = false;
			this.reports.chunker = new Chunker(r);
		});
	}

	onReportRowClick(report) {
		this.reports.selected = report;
		this.reports.selectedId = report.Id;
		this.rejected.loading = true;

		this.api.retrieveCurrentQARReportRejectedUsers(report.Id).then(r => {
			this.rejected.loading = false;
			if (Array.isArray(r)) {
				let waitCount = 0;
				this.rejected.tableHeaders[5]['filterValue'] = 'Implement';
				for (const row of r) {
					if (row.StatusId && ReportRejectedUsersPageComponent.row_value_Status(row) !== 'Implement') {
						waitCount++;
					}
					if (row.LastCheckedStatus === 'done_verified') {
						this.verificationDropdown.hidden[row.Id] = true;
					}
				}
				this.rejected.waitCount = waitCount;
				this.rejected.chunker = new Chunker(r);
			} else {
				alert('sorry, failed to load the datasets,please try again');
			}


		}, e => {
			this.rejected.loading = false;
			alert('sorry, failed to load the datasets,please try again');
		});

	}

	public alert(text, title = 'Warning') {
		this.modalAlert.display = true;
		this.modalAlert.title = title;
		this.modalAlert.text = text;
		this.modalAlert.cb = (yesorno) => {
			this.modalAlert.display = false;
		};
	}

	public modalAlert = {
		display: false,
		title: '',
		text: '',
		cb: (yesorno) => {
		}
	};

	public comments = {
		saving: {}
	};

	public comments_save(d: ReportRowEntity) {
		this.comments.saving[d.Id] = true;
		console.log('comments_save', d);
		this.api.updateRejectedUserComments(this.reports.selectedId, d.Id, d.RejectedUserComments).then(r => {
			this.reports_init();
			this.alert('Record has been saved successfully.', '');
		}, e => {
			console.log(e);
			this.alert('Sorry, could not saved at this moment');
		}).finally(() => {
			this.comments.saving[d.Id] = false;
		});

		return;
	}

	public lastKnownStatus(status, d: ReportRowEntity) {

		this.api.lastKnowStatusOfUserAccess(d.Id, status).then((result: any) => {
			d.LastCheckedStatus = result['LastCheckedStatus'];
			d.LastCheckedDate = result['LastCheckedDate'];
			// this.reports_init();
			this.alert('Record has been saved successfully.', '');
		}, e => {
			console.log(e);
			this.alert('Sorry, could not saved at this moment');
		});

		return;
	}

	public testAccess = {
		testingResult: {},
		testing: {},
		results: {},
		hasResults: {},
		errors: {}
	};

	public testAccess_test(row) {
		console.log('testAccess_test', row);
		this.testAccess.testing[row.Id] = true;
		this.testAccess.results[row.Id] = null;
		this.testAccess.errors[row.Id] = false;
		this.testAccess.hasResults[row.Id] = false;
		this.testAccess.results[row.Id] = true;
		this.api.testIfAccessHasBeenRemoved([row.SystemBatchRow.Id]).then((result: any) => {
			this.testAccess.testingResult[row.SystemBatchRow.Id] = result[0];
		}, e => {
			this.testAccess.testingResult[row.SystemBatchRow.Id] = {Error: true, ErrorType: e};
		}).finally(() => {
			this.testAccess.testing[row.Id] = false;
		});
	}

	public testAllUserAccess() {

		this.rejected.loadingRejectedUser = true;
		const rejectedUserData = this.rejected.chunker.getOriginalData();
		const systemBatchRowIds = rejectedUserData.map(row => row.SystemBatchRow.Id);

		this.api.testIfAccessHasBeenRemoved(systemBatchRowIds).then((result: any[]) => {
			result.forEach(element => {
				this.testAccess.testingResult[element['SystemBatchesRowId']] = element;
			});

			this.rejected.chunker = new Chunker(rejectedUserData);
			this.rejected.loadingRejectedUser = false;

		});

	}

}
